export const environment = {
			production: false,
			apiEnvironment: 'Dev',
			apiRoot: 'https://api.trbportal.com',
			nodeApiRoot: 'https://api.optimizeclientapi1.lcross.sandbox.portal.trb.bank',
			cognitoRegion: 'us-east-1',
			cognitoUserPoolId: 'us-east-1_DqiwKmEQy',
			cognitoAppClientId: '5eckde4ksaj7llppbojpbchda5',
			webSocketApiUri: 'wss://websocket.optimizeclientapi1.lcross.sandbox.internal.trb.bank/',
			clientAppUri: 'https://portal1.lcross.sandbox.portal.trb.bank',
			extIdentityProviderRoot: 'https://auth.optimizeclientapi1.lcross.sandbox.portal.trb.bank',
			plaidVerificationTemplate: 'idvtmp_51U3nsbLGA96V7',
			plaidEnv: 'sandbox',
			consoleLogLevel: 'NONE'
		};
		